// videoTutorials.ts - Configuration for all video tutorials
import type { VideoTutorialConfig } from '../components/VideoTutorial';

/**
 * Video Tutorial Configuration
 * 
 * Instructions for updating:
 * 1. Record videos using scripts from docs/VIDEO_TUTORIAL_SCRIPTS.md
 * 2. Upload to YouTube (unlisted), Vimeo, or your own hosting
 * 3. Update the videoUrl below with the correct URL
 * 4. For YouTube: Use full watch URL (will be auto-converted to embed)
 * 5. For direct MP4: Upload to public/ folder or CDN and use absolute path
 */

export const videoTutorials: VideoTutorialConfig[] = [
  {
    id: 'home-calculator',
    title: 'Getting Started with Your Birth Chart',
    description: 'Learn how to enter birth details and generate your personalized Vedic chart',
    duration: '90 seconds',
    // TODO: Replace with actual video URL after recording
    videoUrl: 'https://www.youtube.com/watch?v=PLACEHOLDER_VIDEO_ID',
    // Or use direct video file:
    // videoUrl: '/videos/home-calculator-intro.mp4',
    thumbnail: '/thumbnails/home-calculator.jpg', // Optional
  },
  {
    id: 'my-chart',
    title: 'Your Detailed Astrological Profile',
    description: 'Explore your complete birth chart with interactive planet details',
    duration: '75 seconds',
    videoUrl: 'https://www.youtube.com/watch?v=PLACEHOLDER_VIDEO_ID',
  },
  {
    id: 'current-period',
    title: 'Understanding Your Life Timeline',
    description: 'Navigate through Vimshottari Dasha periods and their influences',
    duration: '80 seconds',
    videoUrl: 'https://www.youtube.com/watch?v=PLACEHOLDER_VIDEO_ID',
  },
  {
    id: 'yogas-predictions',
    title: 'AI-Powered Future Insights',
    description: 'Discover predictions, classical yogas, and timing windows',
    duration: '90 seconds',
    videoUrl: 'https://www.youtube.com/watch?v=PLACEHOLDER_VIDEO_ID',
  },
  {
    id: 'chat-assistant',
    title: 'Your Personal Astrology Advisor',
    description: 'Ask questions and get personalized answers about your chart',
    duration: '70 seconds',
    videoUrl: 'https://www.youtube.com/watch?v=PLACEHOLDER_VIDEO_ID',
  },
  {
    id: 'detailed-synopsis',
    title: 'Complete Chart Analysis',
    description: 'Access your full astrological report with house and yoga analysis',
    duration: '60 seconds',
    videoUrl: 'https://www.youtube.com/watch?v=PLACEHOLDER_VIDEO_ID',
  },
];

// Helper to get video by ID
export const getVideoTutorial = (id: string): VideoTutorialConfig | undefined => {
  return videoTutorials.find(v => v.id === id);
};

// Map tab values to video IDs
export const tabToVideoMap: Record<string, string> = {
  calculator: 'home-calculator',
  profile: 'my-chart',
  dasha: 'current-period',
  feeds: 'yogas-predictions',
  chat: 'chat-assistant',
  mychart: 'detailed-synopsis',
};
